export const cardDetailSx = {
  "& .detail .title": {
    fontSize: "0.6rem",
    letterSpacing: 0,
    color: "var(--surface-dark)",
  },
  "& .detail .title-val": {
    fontWeight: 600,
    fontSize: "0.7rem",
    letterSpacing: 0,
    color: "var(--neutral-700)",
    "&.main": { color: "var(--neutral-700)" },
  },
  "& .campaign-name": {
    fontSize: "0.8rem",
    fontWeight: 600,
  },
};

export const cardWrapperSx = {
  "& .card": {
    background: "var(--neutral-white)",
    boxShadow: "none",
    border: "1px solid var(--neutral-200)",
    borderRadius: "var(--radius-container)",
    "&:hover": {
      boxShadow: "none",
    },
    "& .card-footer": {
      paddingTop: 0,
      background: "var(--neutral-white)",
      border: 0,
      borderRadius: "var(--radius-container)",
    },
  },
};

export const brandMatchTagSx = {
  "& .brand-match-tag": {
    position: "absolute",
    top: 0,
    fontSize: 10,
    fontWeight: 600,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "90%",
    textAlign: "center",
    "& .tag": {
      backgroundColor: "var(--primary-base)",
      color: "var(--palette-primary-contrastText)",
      padding: "0.1rem 1rem",
      borderTopLeftRadius: "initial",
      borderTopRightRadius: "initial",
      borderBottomRightRadius: "var(--radius-round)",
      borderBottomLeftRadius: "var(--radius-round)",
    },
  },
};
